import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const FolderPixelIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2022_14979)">
        <path d="M39 45H3V48H39V45Z" fill={fillColor || 'black'} />
        <path d="M3 12H0V45H3V12Z" fill={fillColor || 'black'} />
        <path d="M42 18H39V45H42V42H45V39H42V18Z" fill={fillColor || 'black'} />
        <path d="M39 15H21V18H39V15Z" fill={fillColor || 'black'} />
        <path d="M21 12H18V15H21V12Z" fill={fillColor || 'black'} />
        <path d="M18 12V9H6V3H3V12H18Z" fill={fillColor || 'black'} />
        <path d="M48 3H45V39H48V3Z" fill={fillColor || 'black'} />
        <path d="M45 0H6V3H45V0Z" fill={fillColor || 'black'} />
      </g>
      <defs>
        <clipPath id="clip0_2022_14979">
          <rect width="48" height="48" fill={fillColor || 'white'} />
        </clipPath>
      </defs>
    </svg>
  );
};

export { FolderPixelIcon };
